<div class="profile-wrapper">
    <div class="page-header">
        <div class="header-row">
            <div></div><!-- spacer -->
            <div class="page-actions-right" *ngIf="activeTab === 'admins'">
                <button class="btn-primary" (click)="openAddAdminModal()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Add Admin
                </button>
            </div>
        </div>
    </div>
    <div class="profile-component">
        <div class="profile-container">

            <!-- TABS SECTION (Styled like Companies Filters) -->
            <div class="filters-section">
                <div class="filters-row">
                    <div class="filter-chip" [class.active]="activeTab === 'profile'" (click)="switchTab('profile')">
                        My Profile
                    </div>
                    <div class="filter-chip" [class.active]="activeTab === 'admins'" (click)="switchTab('admins')">
                        Admins
                        <span class="count">{{ totalAdmins }}</span>
                    </div>
                </div>
            </div>

            <!-- MY PROFILE TAB CONTENT -->
            <div class="tab-content" *ngIf="activeTab === 'profile'">
                <div class="profile-layout-wrapper">

                    <!-- LEFT SIDEBAR - PROFILE CARD -->
                    <div class="profile-sidebar">
                        <ng-container *ngIf="!isLoading; else sidebarSkeleton">
                            <div class="profile-card-sidebar">
                                <div class="profile-avatar-wrapper">
                                    <img *ngIf="profileData?.profile_image" [src]="profileData.profile_image"
                                        class="profile-image" [class.uploading]="isUploadingPhoto" alt="Profile Photo" />
                                    <div *ngIf="!profileData?.profile_image" class="initials-circle" [class.uploading]="isUploadingPhoto">
                                        {{ profileData?.first_name?.charAt(0) }}{{ profileData?.last_name?.charAt(0) }}
                                    </div>

                                    <!-- Loading Spinner Overlay -->
                                    <div class="avatar-upload-overlay" *ngIf="isUploadingPhoto">
                                        <svg class="spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    </div>

                                    <button class="edit-avatar-btn" (click)="photoInput.click()" [disabled]="isUploadingPhoto"
                                        title="Change Profile Photo">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path
                                                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                        </svg>
                                    </button>
                                    <input type="file" #photoInput class="hidden-input" accept="image/*" [disabled]="isUploadingPhoto"
                                        (change)="onProfilePhotoChange($event)" title="Profile Photo Input">
                                </div>

                                <div class="sidebar-user-info">
                                    <h2 class="sidebar-name">{{ profileData?.first_name }} {{ profileData?.last_name }}
                                    </h2>
                                    <div style="margin-bottom: 8px;">
                                        <span *ngIf="profileData?.is_staff && profileData?.is_superuser; else regularAdminBadge" class="admin-role-badge super">
                                            SA
                                        </span>
                                        <ng-template #regularAdminBadge>
                                            <span class="admin-role-badge">Admin</span>
                                        </ng-template>
                                    </div>
                                    <p class="sidebar-joined">Joined: <strong>{{ profileData?.date_joined | date
                                            }}</strong>
                                    </p>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #sidebarSkeleton>
                            <div class="profile-card-sidebar">
                                <div class="skeleton-block skeleton-avatar"></div>
                                <div class="skeleton-sidebar-info">
                                    <div class="skeleton-block skeleton-name"></div>
                                    <div class="skeleton-block skeleton-sub"></div>
                                    <div class="skeleton-block skeleton-sub" style="width: 80px;"></div>
                                </div>
                            </div>
                        </ng-template>
                    </div>

                    <!-- RIGHT CONTENT AREA -->
                    <div class="profile-main-content">
                        <ng-container *ngIf="!isLoading; else mainContentSkeleton">
                            <!-- ACCOUNT SETTINGS SECTION -->
                            <div class="details-section">
                                <div class="section-header-row">
                                    <div class="section-title">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                        <h3>Account Settings</h3>
                                    </div>
                                    <div class="section-actions">
                                        <button type="button" class="btn-save-action" (click)="saveProfile()"
                                            [disabled]="profileForm.pristine || isUpdatingProfile"
                                            [class.loading]="isUpdatingProfile">
                                            <ng-container *ngIf="!isUpdatingProfile; else profileSaving">
                                                Save Changes
                                            </ng-container>
                                            <ng-template #profileSaving>
                                                <svg class="spinner" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor">
                                                    <circle class="opacity-25" cx="12" cy="12" r="10"
                                                        stroke="currentColor" stroke-width="4"></circle>
                                                    <path class="opacity-75" fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                                    </path>
                                                </svg>
                                                <span>Saving...</span>
                                            </ng-template>
                                        </button>
                                    </div>
                                </div>

                                <form [formGroup]="profileForm" class="info-grid-layout">
                                    <div class="info-group-box">
                                        <label class="box-label">First Name</label>
                                        <div class="box-value-wrapper">
                                            <input type="text" formControlName="firstName" placeholder="First Name"
                                                title="First Name">
                                        </div>
                                        <div class="error-text"
                                            *ngIf="profileForm.get('firstName')?.touched && profileForm.get('firstName')?.errors?.['required']">
                                            <svg fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span>First Name is required</span>
                                        </div>
                                    </div>
                                    <div class="info-group-box">
                                        <label class="box-label">Last Name</label>
                                        <div class="box-value-wrapper">
                                            <input type="text" formControlName="lastName" placeholder="Last Name"
                                                title="Last Name">
                                        </div>
                                        <div class="error-text"
                                            *ngIf="profileForm.get('lastName')?.touched && profileForm.get('lastName')?.errors?.['required']">
                                            <svg fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span>Last Name is required</span>
                                        </div>
                                    </div>
                                    <div class="info-group-box">
                                        <label class="box-label">Email Address</label>
                                        <div class="box-value-wrapper readonly">
                                            <input type="email" formControlName="email" placeholder="Email Address"
                                                title="Email Address" readonly>
                                        </div>
                                    </div>
                                    <div class="info-group-box">
                                        <label class="box-label">Phone Number</label>
                                        <div class="phone-box-wrapper">
                                            <select formControlName="countryCode" class="country-select"
                                                title="Country Code">
                                                <option *ngFor="let country of countryCodes"
                                                    [value]="country.dial_code">{{
                                                    country.code }} ({{ country.dial_code }})</option>
                                            </select>
                                            <input type="tel" formControlName="phone" placeholder="Phone number"
                                                maxlength="10" title="Phone Number" (keypress)="onKeyPress($event)">
                                        </div>
                                        <div class="error-text"
                                            *ngIf="profileForm.get('phone')?.touched && (profileForm.get('phone')?.errors?.['required'] || profileForm.get('phone')?.errors?.['pattern'])">
                                            <svg fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span *ngIf="profileForm.get('phone')?.errors?.['required']">Phone Number is
                                                required</span>
                                            <span *ngIf="profileForm.get('phone')?.errors?.['pattern']">Enter a valid
                                                10-digit
                                                mobile number</span>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <!-- SECURITY SECTION -->
                            <div class="details-section security-section">
                                <div class="section-header-row">
                                    <div class="section-title">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                        </svg>
                                        <h3>Security & Password</h3>
                                    </div>
                                </div>

                                <!-- OTP Verification Block -->
                                <div class="otp-verification-block" *ngIf="isOtpSent">
                                    <p class="otp-hint">
                                        OTP sent to your {{ inputType === 'email' ? 'email' : 'phone number' }}.
                                    </p>
                                    <div class="otp-input-container">
                                        <input *ngFor="let d of [0,1,2,3,4,5]; let i = index" type="text" maxlength="1"
                                            [id]="'otp' + (i + 1)" (input)="onOtpInput($event, i)"
                                            (keydown)="onOtpKeydown($event, i)" (paste)="onOtpPaste($event)"
                                            class="otp-digit" title="OTP digit" autocomplete="one-time-code"
                                            [value]="otp[i]">
                                    </div>
                                    <div class="otp-footer">
                                        <button class="btn-resend" (click)="onResendOtp()"
                                            [disabled]="isResendOtpDisabled">
                                            Resend OTP {{ isResendOtpDisabled ? '(' + getResendOtpTimerDisplay() + 's)'
                                            : ''
                                            }}
                                        </button>
                                        <button type="button" class="btn-save-action" (click)="updatePassword()"
                                            [disabled]="isUpdatingPassword" [class.loading]="isUpdatingPassword">
                                            <ng-container *ngIf="!isUpdatingPassword; else passwordUpdating">
                                                Verify & Update
                                            </ng-container>
                                            <ng-template #passwordUpdating>
                                                <svg class="spinner" viewBox="0 0 24 24" fill="none"
                                                    stroke="currentColor">
                                                    <circle class="opacity-25" cx="12" cy="12" r="10"
                                                        stroke="currentColor" stroke-width="4"></circle>
                                                    <path class="opacity-75" fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                                    </path>
                                                </svg>
                                                <span>Verifying...</span>
                                            </ng-template>
                                        </button>
                                    </div>
                                </div>

                                <form [formGroup]="passwordForm" class="info-grid-layout" *ngIf="!isOtpSent">
                                    <div class="info-group-box">
                                        <label class="box-label">New Password</label>
                                        <div class="box-value-wrapper">
                                            <input [type]="showNewPassword ? 'text' : 'password'"
                                                formControlName="newPassword" placeholder="Minimum 6 characters"
                                                title="New Password">
                                            <button type="button" class="toggle-visibility"
                                                (click)="togglePasswordVisibility('new')"
                                                title="Toggle Password Visibility"
                                                aria-label="Toggle password visibility">
                                                <!-- Eye -->
                                                <svg *ngIf="!showNewPassword" xmlns="http://www.w3.org/2000/svg"
                                                    fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                    stroke="currentColor" class="icon-sm">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12.008a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                <!-- Eye Slash -->
                                                <svg *ngIf="showNewPassword" xmlns="http://www.w3.org/2000/svg"
                                                    fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                    stroke="currentColor" class="icon-sm">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                                                </svg>
                                            </button>
                                        </div>
                                        <div class="error-text"
                                            *ngIf="passwordForm.get('newPassword')?.touched && (passwordForm.get('newPassword')?.errors?.['minlength'] || passwordForm.get('newPassword')?.errors?.['required'])">
                                            <svg fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span *ngIf="passwordForm.get('newPassword')?.errors?.['required']">New
                                                Password
                                                is
                                                required</span>
                                            <span
                                                *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">Password
                                                must
                                                be at least 6 characters</span>
                                        </div>
                                    </div>
                                    <div class="info-group-box">
                                        <label class="box-label">Confirm Password</label>
                                        <div class="box-value-wrapper">
                                            <input [type]="showConfirmPassword ? 'text' : 'password'"
                                                formControlName="confirmPassword" placeholder="Repeat new password"
                                                title="Confirm Password">
                                            <button type="button" class="toggle-visibility"
                                                (click)="togglePasswordVisibility('confirm')"
                                                title="Toggle Password Visibility"
                                                aria-label="Toggle confirmation password visibility">
                                                <!-- Eye -->
                                                <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg"
                                                    fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                    stroke="currentColor" class="icon-sm">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12.008a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                <!-- Eye Slash -->
                                                <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg"
                                                    fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                    stroke="currentColor" class="icon-sm">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                                                </svg>
                                            </button>
                                        </div>
                                        <div class="error-text"
                                            *ngIf="passwordForm.get('confirmPassword')?.touched && (passwordForm.errors?.['passwordMismatch'] || passwordForm.get('confirmPassword')?.errors?.['required'])">
                                            <svg fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                            <span
                                                *ngIf="passwordForm.get('confirmPassword')?.errors?.['required']">Confirm
                                                Password is required</span>
                                            <span
                                                *ngIf="!passwordForm.get('confirmPassword')?.errors?.['required'] && passwordForm.errors?.['passwordMismatch']">Passwords
                                                do not match</span>
                                        </div>
                                    </div>
                                </form>
                                <div class="form-actions-footer" *ngIf="!isOtpSent">
                                    <button type="button" class="btn-save-action" (click)="sendOTP()"
                                        [disabled]="isUpdatingPassword" [class.loading]="isUpdatingPassword">
                                        Update Password
                                    </button>
                                </div>
                            </div>

                            <!-- SUBSCRIPTION SECTION -->
                            <div class="details-section plan-section">
                                <div class="plan-hero-card">
                                    <div class="plan-visual-icon">👑</div>
                                    <div class="plan-text-content">
                                        <span class="plan-small-label">Current Plan</span>
                                        <h2 class="plan-main-title">{{ subscription?.type }}</h2>
                                    </div>
                                    <div class="plan-status-badge">Active</div>
                                </div>

                                <div class="plan-stats-grid">
                                    <div class="plan-stat-item">
                                        <span class="plan-stat-label">Expiry Date</span>
                                        <span class="plan-stat-value">{{ subscription?.expired | date: 'dd MMM, yyyy'
                                            }}</span>
                                    </div>
                                    <div class="plan-stat-item">
                                        <span class="plan-stat-label">Plan Price</span>
                                        <span class="plan-stat-value">${{ subscription?.price }}</span>
                                    </div>
                                    <div class="plan-stat-item">
                                        <span class="plan-stat-label">Max Admins</span>
                                        <span class="plan-stat-value">{{ subscription?.max_admin_limit }}</span>
                                    </div>
                                    <div class="plan-stat-item">
                                        <span class="plan-stat-label">Max Drivers</span>
                                        <span class="plan-stat-value">{{ subscription?.max_drivers_limit }}</span>
                                    </div>
                                    <div class="plan-stat-item">
                                        <span class="plan-stat-label">Max Locations</span>
                                        <span class="plan-stat-value">{{ subscription?.location }}</span>
                                    </div>
                                    <div class="plan-stat-item">
                                        <span class="plan-stat-label">Archived Orders</span>
                                        <span class="plan-stat-value">{{ subscription?.archive_order_retention_duration
                                            }} months
                                            Retained</span>
                                    </div>
                                    <div class="plan-stat-item full-width">
                                        <span class="plan-stat-label">Secret Key</span>
                                        <div class="secret-key-wrapper">
                                            <span class="plan-stat-value secret-value">
                                                {{ showSecretKey ? organization?.api_key : '••••••••••••••••' }}
                                            </span>
                                            <div class="secret-actions">
                                                <button type="button" class="action-btn-mini"
                                                    (click)="toggleSecretKey()" title="Show/Hide">
                                                    <!-- Eye -->
                                                    <svg *ngIf="!showSecretKey" xmlns="http://www.w3.org/2000/svg"
                                                        fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                        stroke="currentColor" class="icon-sm">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M15 12.008a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    </svg>
                                                    <!-- Eye Slash -->
                                                    <svg *ngIf="showSecretKey" xmlns="http://www.w3.org/2000/svg"
                                                        fill="none" viewBox="0 0 24 24" stroke-width="2"
                                                        stroke="currentColor" class="icon-sm">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                                                    </svg>
                                                </button>
                                                <button type="button" class="action-btn-mini" (click)="copySecretKey()"
                                                    title="Copy Key">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                        viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                                                        class="icon-sm">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="plan-action-footer">
                                    <button type="button" class="btn-cancel-plan" (click)="cancelSubscription()">Cancel
                                        Subscription</button>
                                    <button type="button" class="btn-upgrade-plan" (click)="upgradePlan()">Upgrade
                                        Plan</button>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #mainContentSkeleton>
                            <!-- Account Settings Skeleton -->
                            <div class="details-section">
                                <div class="skeleton-section-header">
                                    <div class="skeleton-block skeleton-icon-box"></div>
                                    <div class="skeleton-block skeleton-title-box"></div>
                                </div>
                                <div class="info-grid-layout">
                                    <div class="skeleton-info-item" *ngFor="let item of [1,2,3,4]">
                                        <div class="skeleton-block skeleton-label"></div>
                                        <div class="skeleton-block skeleton-input"></div>
                                    </div>
                                </div>
                            </div>

                            <!-- Security Skeleton -->
                            <div class="details-section">
                                <div class="skeleton-section-header">
                                    <div class="skeleton-block skeleton-icon-box"></div>
                                    <div class="skeleton-block skeleton-title-box"></div>
                                </div>
                                <div class="info-grid-layout">
                                    <div class="skeleton-info-item" *ngFor="let item of [1,2]">
                                        <div class="skeleton-block skeleton-label"></div>
                                        <div class="skeleton-block skeleton-input"></div>
                                    </div>
                                </div>
                            </div>

                            <!-- Plan Skeleton -->
                            <div class="details-section">
                                <div class="skeleton-plan-hero">
                                    <div class="skeleton-block skeleton-plan-icon"></div>
                                    <div class="skeleton-plan-text">
                                        <div class="skeleton-block skeleton-plan-label"></div>
                                        <div class="skeleton-block skeleton-plan-title"></div>
                                    </div>
                                </div>
                                <div class="plan-stats-grid">
                                    <div class="skeleton-block skeleton-stat-item" *ngFor="let i of [1,2,3,4,5,6]">
                                    </div>
                                    <div class="skeleton-block skeleton-stat-item" style="grid-column: span 3;"></div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <!-- END MY PROFILE TAB -->

            <!-- ADMIN LIST TAB CONTENT -->
            <div class="tab-content" *ngIf="activeTab === 'admins'">

                <div class="admin-list">
                    <ng-container *ngIf="!isLoading; else adminsSkeleton">
                        <!-- Admin Card List (Double Guarded) -->
                        <ng-container *ngIf="activeTab === 'admins'">
                            <div class="admin-card" *ngFor="let admin of admins; let i = index"
                                [class.deactivated-admin]="admin.admin_status === false || admin.is_active === false">
                                <div class="admin-header" (click)="toggleAdminDetails(i)">
                                    <div class="admin-avatar default">
                                        <ng-container *ngIf="admin.profile_image; else initials">
                                            <img [src]="admin.profile_image" alt="{{ admin.first_name }}">
                                        </ng-container>
                                        <ng-template #initials>
                                            <span>{{ getAdminInitials(admin) }}</span>
                                        </ng-template>
                                    </div>
                                    <div class="admin-info">
                                        <div class="admin-name-row">
                                            <span class="admin-name">{{ admin.first_name }} {{ admin.last_name }}</span>
                                            <div class="admin-badges">
                                                <!-- Case 1: Staff & Superuser -->
                                                <span *ngIf="admin.is_staff && admin.is_superuser"
                                                    class="admin-role-badge super">
                                                    SA
                                                </span>

                                                <!-- Case 2: Shipped & Receiving Admin but NOT Staff+Superuser -->
                                                <span
                                                    *ngIf="admin.is_shipped_admin && admin.is_receiving_admin && !(admin.is_staff && admin.is_superuser)"
                                                    class="admin-role-badge">
                                                    Both
                                                </span>

                                                <!-- Case 3: Only Shipped Admin -->
                                                <span *ngIf="admin.is_shipped_admin && !admin.is_receiving_admin"
                                                    class="admin-role-badge">
                                                    Shipping
                                                </span>

                                                <!-- Case 4: Only Receiving Admin -->
                                                <span *ngIf="!admin.is_shipped_admin && admin.is_receiving_admin"
                                                    class="admin-role-badge">
                                                    Receiving
                                                </span>

                                                <!-- Inactive Status Badge -->
                                                <span *ngIf="admin.admin_status === false || admin.is_active === false"
                                                    class="admin-role-badge inactive-badge">
                                                    Inactive
                                                </span>
                                            </div>
                                        </div>
                                        <div class="admin-department">
                                            <!-- Super Admin -->
                                            <span *ngIf="admin.is_staff && admin.is_superuser">
                                                Super Administrator
                                            </span>

                                            <!-- Both Shipping & Receiving -->
                                            <span
                                                *ngIf="admin.is_shipped_admin && admin.is_receiving_admin && !(admin.is_staff && admin.is_superuser)">
                                                Both Departments
                                            </span>

                                            <!-- Only Shipping -->
                                            <span *ngIf="admin.is_shipped_admin && !admin.is_receiving_admin">
                                                Shipping Department
                                            </span>

                                            <!-- Only Receiving -->
                                            <span *ngIf="!admin.is_shipped_admin && admin.is_receiving_admin">
                                                Receiving Department
                                            </span>
                                        </div>

                                    </div>
                                    <div class="admin-actions">
                                        <button class="btn-icon call"
                                            (click)="callAdmin(admin); $event.stopPropagation()"
                                            matTooltip="Call Admin">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                            </svg>
                                        </button>
                                        <button class="btn-icon"
                                            matTooltip="{{ profileData?.is_staff && profileData?.is_superuser ? '' : 'Don\'t have permission for edit' }}"
                                            (click)="profileData?.is_staff && profileData?.is_superuser ? editAdmin(admin) : null; $event.stopPropagation()">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                            </svg>
                                        </button>

                                         <button class="btn-icon status-toggle"
                                            *ngIf="!(admin.is_staff && admin.is_superuser)"
                                            [class.inactive]="admin.admin_status === false || admin.is_active === false"
                                            [disabled]="!(profileData?.is_staff && profileData?.is_superuser)"
                                            matTooltip="{{ profileData?.is_staff && profileData?.is_superuser ? ((admin.admin_status !== false && admin.is_active !== false) ? 'Deactivate Admin' : 'Activate Admin') : 'Don\'t have permission to deactivate' }}"
                                            (click)="profileData?.is_staff && profileData?.is_superuser ? toggleAdminStatus(admin) : null; $event.stopPropagation()">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                            </svg>
                                        </button>

                                        <button class="btn-icon delete delete-btn"
                                            [disabled]="!(profileData?.is_staff && profileData?.is_superuser)"
                                            matTooltip="{{ profileData?.is_staff && profileData?.is_superuser ? '' : 'Don\'t have permission for delete' }}"
                                            (click)="profileData?.is_staff && profileData?.is_superuser ? deleteAdmin(admin.id) : null; $event.stopPropagation()">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                            </svg>
                                        </button>

                                        <button class="btn-expand" [class.expanded]="admin.expanded"
                                            title="Toggle Details">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div class="admin-details" [class.show]="admin.expanded">
                                    <div class="detail-grid">
                                        <div class="detail-item-admin">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor" class="detail-icon">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                                            </svg>
                                            <div class="detail-content">
                                                <div class="detail-label-admin">Email</div>
                                                <div class="detail-value-admin">
                                                    {{ admin.email }}
                                                    <button class="copy-btn" (click)="copyToClipboard(admin.email)"
                                                        title="Copy Email">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="detail-item-admin" *ngIf="admin.phone_number">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor" class="detail-icon">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                            </svg>
                                            <div class="detail-content">
                                                <div class="detail-label-admin">Phone Number</div>
                                                <div class="detail-value-admin">
                                                    {{ admin.country_code }} {{ admin.phone_number }}
                                                    <button class="copy-btn"
                                                        (click)="copyToClipboardPhone(admin.country_code, admin.phone_number)">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="detail-item-admin">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="2" stroke="currentColor" class="detail-icon">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
                                            </svg>
                                            <div class="detail-content">
                                                <div class="detail-label-admin">Joined Date</div>
                                                <div class="detail-value-admin">{{ convertToLocalDate(admin.date_joined)
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-template #adminsSkeleton>
                        <div class="skeleton-admin-card" *ngFor="let i of [1,2,3,4,5,6]">
                            <div class="skeleton-block skeleton-admin-avatar"></div>
                            <div class="skeleton-admin-info">
                                <div class="skeleton-block skeleton-admin-name"></div>
                                <div class="skeleton-block skeleton-admin-dept"></div>
                            </div>
                            <div class="skeleton-admin-actions">
                                <div class="skeleton-block skeleton-circle-btn"></div>
                                <div class="skeleton-block skeleton-circle-btn"></div>
                            </div>
                        </div>
                    </ng-template>
                </div>

            </div>

            <!-- Pagination removed as per user request -->


        </div>
        <!-- END ADMIN LIST TAB -->

    </div>
</div>
<!-- END PROFILE COMPONENT -->

<!-- ADD ADMIN MODAL -->
<div class="modal-overlay" [class.show]="showAddAdminModal"
    (click)="$event.target === $event.currentTarget && closeAddAdminModal()">
    <div class="modal">
        <div class="modal-header">
            <h2 *ngIf="!isEditAdmin" class="modal-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" class="modal-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                </svg>
                Add Admin
            </h2>
            <h2 *ngIf="isEditAdmin" class="modal-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" class="modal-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                </svg>
                Edit Admin
            </h2>
            <button class="btn-close-modal" (click)="closeAddAdminModal()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <!-- Profile Photo Section -->
            <div class="modal-photo-section">
                <div class="modal-photo-wrapper">
                    <div class="modal-photo">
                        <ng-container *ngIf="adminPhotoPreview; else placeholder">
                            <img [src]="adminPhotoPreview" alt="Admin Photo">
                        </ng-container>
                        <ng-template #placeholder>
                            <span class="modal-photo-placeholder">👤</span>
                        </ng-template>
                    </div>
                    <!-- Button uses TypeScript ViewChild ref — not template variable -->
                    <button type="button" class="modal-edit-photo-btn" title="Upload Photo"
                        (click)="triggerAdminPhotoInput()">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
                        </svg>
                    </button>
                </div>
                <p class="modal-change-text">Upload Profile Photo (Optional)</p>
            </div>

            <form [formGroup]="addAdminForm">
                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                        </svg>
                        First Name
                        <span class="required">*</span>
                    </label>
                    <input type="text" class="form-input-modal" formControlName="firstName"
                        placeholder="Enter first name" title="First Name">
                    <small class="error-text" *ngIf="
    addAdminForm.get('firstName')?.invalid &&
    addAdminForm.get('firstName')?.touched
  ">
                        First name is required
                    </small>
                </div>

                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                        </svg>
                        Last Name
                        <span class="required">*</span>
                    </label>
                    <input type="text" class="form-input-modal" formControlName="lastName" placeholder="Enter last name"
                        title="Last Name">
                    <small class="error-text" *ngIf="
    addAdminForm.get('lastName')?.invalid &&
    addAdminForm.get('lastName')?.touched
  ">
                        Last name is required
                    </small>
                </div>

                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                        </svg>
                        Email
                        <span class="required">*</span>
                    </label>
                    <input type="email" class="form-input-modal" formControlName="email" placeholder="admin@company.com"
                        [readonly]="isEditAdmin" title="Email Address">
                    <small class="error-text" *ngIf="
    addAdminForm.get('email')?.touched &&
    addAdminForm.get('email')?.invalid
  ">
                        <span *ngIf="addAdminForm.get('email')?.errors?.['required']">
                            Email is required
                        </span>
                        <span *ngIf="addAdminForm.get('email')?.errors?.['email']">
                            Enter a valid email address
                        </span>
                    </small>
                </div>

                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                        </svg>
                        Country
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Phone Number
                    </label>
                    <div class="modal-phone-grid">
                        <select class="form-input-modal" formControlName="countryCode" title="Country Code">
                            <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                                {{ country.code }} {{ country.dial_code }}
                            </option>
                        </select>
                        <input type="tel" class="form-input-modal" formControlName="phone"
                            placeholder="Phone number (optional)" (keypress)="onKeyPress($event)" title="Phone Number">

                    </div>
                    <small class="error-text" *ngIf="
    addAdminForm.get('phone')?.touched &&
    addAdminForm.get('phone')?.errors?.['pattern']
  ">
                        Enter a valid 10-digit mobile number
                    </small>
                </div>

                <div class="modal-form-group">
                    <label class="form-label">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="label-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z" />
                        </svg>
                        Department
                        <span class="required">*</span>
                    </label>
                    <select class="form-input-modal" formControlName="department" [(ngModel)]="optionType"
                        title="Department">
                        <option value="" disabled>Choose Admin Access</option>
                        <option value="shipping">Shipping</option>
                        <option value="receiving">Receiving</option>
                        <option value="both">Both</option>
                    </select>
                    <small class="error-text" *ngIf="
    addAdminForm.get('department')?.touched &&
    addAdminForm.get('department')?.invalid
  ">
                        Department is required
                    </small>

                </div>
            </form>
        </div>

        <div class="modal-actions">
            <button class="btn-modal-secondary" (click)="closeAddAdminModal()">Cancel</button>
            <button *ngIf="!isEditAdmin" class="btn-modal-primary" (click)="addAdmin()" [disabled]="isSubmittingAdmin"
                [class.loading]="isSubmittingAdmin">
                <ng-container *ngIf="!isSubmittingAdmin; else adminAdding">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Add Admin
                </ng-container>
                <ng-template #adminAdding>
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Adding...</span>
                </ng-template>
            </button>
            <button *ngIf="isEditAdmin" class="btn-modal-primary" (click)="updateAdmin()" [disabled]="isSubmittingAdmin"
                [class.loading]="isSubmittingAdmin">
                <ng-container *ngIf="!isSubmittingAdmin; else adminUpdating">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Update Admin
                </ng-container>
                <ng-template #adminUpdating>
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Updating...</span>
                </ng-template>
            </button>
        </div>
    </div>
</div>
<!-- END ADD ADMIN MODAL -->

<div class="modal-backdrop" (click)="closeLogout()" *ngIf="showLogoutPopup">

    <div class="modal-card">

        <!-- Header -->
        <div class="modal-header">
            <h3>Cancel Subscription</h3>
            <button class="close-btn" (click)="closeLogout()">✕</button>
        </div>

        <!-- Body -->
        <div class="modal-body">
            <p>Are you sure you want to cancel subscription?</p>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
            <button class="btn cancel" (click)="closeLogout()">Cancel</button>
            <button class="btn danger" (click)="confirmLogout()">Cancel Subscription</button>
            <!-- <button class="btn danger" (click)="confirmLogout()">Logout</button> -->
        </div>

    </div>

</div>

<!-- ROOT LEVEL file input — always in DOM, completely outside modals -->
<input type="file" #adminPhotoInputRef accept="image/*" (change)="onAdminPhotoChange($event)" title="Admin Photo"
    style="position:fixed; opacity:0; width:1px; height:1px; top:-9999px; left:-9999px;">